import instance from 'api';
import { ApiFailure } from 'apiFailures';

interface SupportTicket {
  ticketId: string;
  attachmentsFailed: boolean;
}

export const createTicket = (message: string, failure: ApiFailure | null, files: File[]) => {
  const formData = new FormData();

  formData.append('request', new Blob([JSON.stringify({ message, error: failure })], { type: 'application/json' }));
  files.forEach((file) => formData.append('files', file));

  return instance()
    .post<SupportTicket>('/support/tickets', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => response.data);
};

export const getWidgetUrl = () =>
  instance()
    .get<{ url: string }>('/support/widget')
    .then((response) => response.data.url);
